export default __webpack_public_path__ + "static/r-pitch-1-4cf92f0f7f40d87eda9f1ebf7a143cf4.jpg";